import {  t  } from "@/client/libs/dummy-i18n";
import { CheckIcon } from "@phosphor-icons/react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@stackmorph/ui";
import { useState } from "react";

type PurchaseAddonModalProps = {
  addon: any;
  isOpen: boolean;
  onClose: () => void;
}

export const PurchaseAddonModal = ({ addon, isOpen, onClose }: PurchaseAddonModalProps) => {
  const [processing, setProcessing] = useState(false);

  if (!addon) return null;

  const handlePurchase = async (provider: string) => {
    setProcessing(true);
    try {
      // Mock purchase - will integrate with payment API
      await new Promise((resolve) => setTimeout(resolve, 1500));
      
      // In production:
      // await fetch(`/api/addons/${addon.id}/purchase`, {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ provider })
      // });
      
      alert(`Purchase successful! ${addon.name} has been added to your account.`);
      onClose();
    } catch {
      alert("Purchase failed. Please try again.");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{t`Purchase ${addon.name}`}</DialogTitle>
          <DialogDescription>
            {t`Complete your purchase to get instant access`}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          {/* Order Summary */}
          <div className="rounded-lg border p-4">
            <div className="mb-2 flex items-start justify-between">
              <div>
                <div className="font-medium">{addon.name}</div>
                <div className="text-sm text-muted-foreground">{addon.description}</div>
              </div>
            </div>
            <div className="mt-3 flex justify-between border-t pt-2">
              <span className="font-semibold">{t`Total`}</span>
              <span className="text-lg font-bold">${addon.price}</span>
            </div>
          </div>

          {/* What's Included */}
          <div>
            <h4 className="mb-2 font-semibold">{t`What's included:`}</h4>
            <ul className="space-y-1">
              {addon.features?.map((feature: string) => (
                <li key={feature} className="flex items-center gap-2 text-sm">
                  <CheckIcon className="h-4 w-4 text-green-500" />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <DialogFooter className="flex-col gap-2 sm:flex-col">
          <Button
            className="w-full"
            disabled={processing}
            onClick={() => {
              void handlePurchase("razorpay");
            }}
          >
            {processing ? t`Processing...` : t`Pay with Razorpay`}
          </Button>
          <Button
            className="w-full"
            disabled={processing}
            variant="outline"
            onClick={() => {
              void handlePurchase("paypal");
            }}
          >
            {t`Pay with PayPal`}
          </Button>
          <Button className="w-full" variant="ghost" onClick={onClose}>
            {t`Cancel`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
